import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentAdmin } from '@/redux/auth/selectors';
import AnnouncementBanner from '@/components/anncoument/AnnoucmentBanner';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import axios from 'axios';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isLoggedIn = window.localStorage.getItem('isLoggedIn'); // Check local storage for login status
  const location = useLocation();
  const currentAdmin = useSelector(selectCurrentAdmin);
  const [employeeDetails, setEmployeeDetails] = useState(null);

  const config = {
    type: 'spring',
    damping: 20,
    stiffness: 100,
  };

  // Fetch employee details for route guard
  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      if (!currentAdmin?._id) return;
      try {
        const { data } = await axios.get('/my/profile');
        if (data.success) {
          setEmployeeDetails(data.employee);
        }
      } catch (err) {
        console.error('PrivateRoute: Failed to fetch employee details:', err);
      }
    };
    fetchEmployeeDetails();

    // Listen for profile updates to re-check
    const handleProfileUpdate = () => fetchEmployeeDetails();
    window.addEventListener('profileStatusChanged', handleProfileUpdate);
    window.addEventListener('reminder_received', handleProfileUpdate);
    return () => {
      window.removeEventListener('profileStatusChanged', handleProfileUpdate);
      window.removeEventListener('reminder_received', handleProfileUpdate);
    };
  }, [currentAdmin?._id]);

  // Route guard: Check if user is critical (3+ reminders & Incomplete profile)
  const reminderCount = employeeDetails?.manualProfileReminderCount || 0;
  const profileStatus = employeeDetails?.profileStatus;
  const isCritical = reminderCount >= 3 && profileStatus === 'Incomplete';

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isLoggedIn) {
          // Redirect to login if not logged in
          return <Redirect to="/login" />;
        }

        // Route guard: Redirect critical users to /my-profile
        if (isCritical && props.location.pathname !== '/my-profile') {
          return <Redirect to="/my-profile" />;
        }

        // Render the component if logged in and super admin
        return (
          <>
            {/* {!location.pathname?.includes('/announcement-feeds') ? <AnnouncementBanner /> : null} */}

            <motion.div
              transition={config}
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -20, opacity: 0 }}
            >
              <Component {...props} />
            </motion.div>
          </>
        );
      }}
    />
  );
};

export default PrivateRoute;







// const PrivateRoute = ({ component: Component, ...rest }) => {
//   const config = {
//     type: 'spring',
//     damping: 20,
//     stiffness: 100,
//   };

//   return (
//     // Show the component only when the admin is logged in
//     // Otherwise, redirect the admin to /signin page

//     <Route
//       {...rest}
//       render={(props) =>
//         window.localStorage.getItem('isLoggedIn') ? (
//           <motion.div
//             transition={config}
//             initial={{ y: 20, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             exit={{ y: -20, opacity: 0 }}
//           >
//             <Component {...props} />
//           </motion.div>
//         ) : (
//           <Redirect to="/login" />
//         )
//       }
//     />
//   );
// };

// export default PrivateRoute;
